export enum EcommerceTrackingSource {
  Search = 'search',
  List = 'wishlist',
  Story = 'postman page',
  Builder = 'builder.io',
}
